import api from './api.js';
class Documents {
    constructor(){
        this.url_documents = 'UploadDocuments'
    }
    upload(data){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        console.log('file',data);
        formData.append('file',data,data.name);
        console.log('formdata',formData);
        return api.post(this.url_documents, formData, headers);
    } 
}

export default new Documents